import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import { forwardRef, useEffect, useImperativeHandle, useRef, } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import debounce from 'lodash/fp/debounce';
const RESIZE_THROTTLING = 100;
const SmoothScrollbars = forwardRef((componentProps, ref) => {
    const { slideIn = false, largeTrack = false, trackOffset = false, className = '', onScroll = noop, tagName = 'div', autoHeight = false, autoHeightMin = 0, autoHeightMax = 200, children, } = componentProps;
    const scrollbarsRef = useRef(null);
    const contentRef = useRef(null);
    useImperativeHandle(ref, () => scrollbarsRef.current);
    useEffect(() => {
        if (!contentRef.current || !scrollbarsRef.current) {
            return;
        }
        const updateScrollbars = debounce(RESIZE_THROTTLING)(() => {
            if (scrollbarsRef.current) {
                // Trigger a update for the scrollbars.
                // This is needed since the lib does not automatically update on content height changes
                // See: https://github.com/RobPethick/react-custom-scrollbars-2/issues/12
                // Use type assertion to tell TypeScript that 'update' exists
                scrollbarsRef.current.update();
            }
        });
        const resizeObserver = new ResizeObserver(updateScrollbars);
        resizeObserver.observe(contentRef.current);
        return () => {
            resizeObserver.disconnect();
            updateScrollbars.cancel();
        };
    }, []);
    const wrapperClassNames = classNames(className, slideIn && 'scrollbar-fly-in', 'smooth-scrollbar-wrapper');
    const renderTrackVerticalNames = classNames('scrollbar-track-vertical', largeTrack && 'scrollbar-track-size-large', trackOffset && 'scrollbar-track-offset');
    const renderThumbVerticalNames = classNames('scrollbar-thumb-vertical', largeTrack && 'scrollbar-thumb-size-large');
    const renderTrackHorizontalNames = classNames('scrollbar-track-horizontal', largeTrack && 'scrollbar-track-size-large', trackOffset && 'scrollbar-track-offset');
    const renderThumbHorizontalNames = classNames('scrollbar-thumb-horizontal', largeTrack && 'scrollbar-thumb-size-large');
    return (_jsx(Scrollbars, { ref: scrollbarsRef, tagName: tagName, onScroll: onScroll, className: wrapperClassNames, hideTracksWhenNotNeeded: true, autoHeight: autoHeight, autoHeightMin: autoHeightMin, autoHeightMax: autoHeightMax, renderView: props => {
            return _jsx("div", { ...props, className: 'scrollbar-view' });
        }, renderTrackVertical: props => {
            return _jsx("div", { ...props, className: renderTrackVerticalNames });
        }, renderThumbVertical: props => {
            return _jsx("div", { ...props, className: renderThumbVerticalNames });
        }, renderTrackHorizontal: props => {
            return _jsx("div", { ...props, className: renderTrackHorizontalNames });
        }, renderThumbHorizontal: props => {
            return _jsx("div", { ...props, className: renderThumbHorizontalNames });
        }, children: _jsx("div", { className: 'scrollbar-content-wrapper', ref: contentRef, children: children }) }));
});
export default SmoothScrollbars;
